import * as React from 'react';
import { useEffect } from 'react';

import DevicePickerService from './device_picker_service';
import WorkbenchManager from './workbench_manager';
import WorkbenchItem from './workbench_item';

import styled from 'styled-components';

import { color, space, fontSize } from '@core-ds/primitives';

const WorkbenchContainer = styled.div`
   width: 350px;
   text-align: left;
   padding: ${space[0]};
   flex: 1;
   overflow: hidden;
`;

const WorkbenchHeaderContainer = styled.div`
   padding: ${space[4]} ${space[0]};
   background-color: ${color.gray1};
   text-align: center;
`;

const WorkbenchHeader = styled.span`
   text-transform: uppercase;
   font-weight: 700;
   font-size: ${fontSize[2]};
   line-height: 1;
   color: ${color.gray6};
`;

const WorkbenchTopicContainer = styled.div`
   max-height: 40vh;
   overflow: auto;
   background-color: ${color.white};
`;

const WorkbenchEmptyMessage = styled.p`
   padding: ${space[5]} ${space[7]};
   margin: ${space[0]};
   font-size: ${fontSize[2]};
   text-align: center;
`;

const WorkbenchAddTopicContainer = styled.div`
   width: 100%;
   height: 72px;
   padding: ${space[4]};
   background-color: ${color.gray1};
`;

const WorkbenchAddTopicButton = styled.button`
   width: 100%;
`;

const TopicList = ({ topics }) => {
   return topics.map(topic => (
      <WorkbenchItem key={`${topic.wikiid}-${topic.variantid}`} topic={topic} />
   ));
};

const EmptyTopicsMessage = () => {
   return (
      <WorkbenchEmptyMessage id="workbench-empty-message">
         {_js('Get quick access to guides, parts and answers for your devices')}
      </WorkbenchEmptyMessage>
   );
};

const Workbench = ({ topics }) => {
   useEffect(WorkbenchManager.getCurrentWorkbench, []);

   const selectDevice = async () => {
      const selectedDevice = await DevicePickerService.selectDevice({
         allowOrphan: false,
         initialView: 'COLUMN',
      });

      // Open Workbench after selecting a device.
      document.getElementById('workbenchDropdownToggle').parentNode.click();

      WorkbenchManager.addItem(
         /* variantid */ null,
         /* wikkiid */ null,
         /* showIndicator */ true,
         selectedDevice
      );
   };

   // if the workbench does not receive topics (loading) do not render anything
   if (!topics) {
      return <WorkbenchContainer id="loading-workbench"></WorkbenchContainer>;
   }

   const hasTopics = topics.length !== 0;
   const Topics = hasTopics ? TopicList : EmptyTopicsMessage;

   return (
      <WorkbenchContainer id="workbench">
         <WorkbenchHeaderContainer>
            <WorkbenchHeader>{_js('My Workbench')}</WorkbenchHeader>
         </WorkbenchHeaderContainer>
         <WorkbenchTopicContainer id="workbench-topic-container">
            <Topics topics={topics} />
         </WorkbenchTopicContainer>
         <WorkbenchAddTopicContainer>
            <WorkbenchAddTopicButton
               id="workbench-add-device"
               className="button button-action-solid"
               onClick={selectDevice}
            >
               {_js('Add a Device')}
            </WorkbenchAddTopicButton>
         </WorkbenchAddTopicContainer>
      </WorkbenchContainer>
   );
};

export default Workbench;
